// extracted by mini-css-extract-plugin
export default {"root":"TextFieldAdornment-root-fe1e76000611aa81af1aee001fabc8d5"};